import {
  map,
  /////////////////
  share
} from "rxjs/operators";

export const multicastingExamples = {
  share: {
    label: "share",
    inputs: [
      [
        { t: 10, c: "1" },
        { t: 20, c: "2" },
        { t: 70, c: "1" }
      ]
    ],
    apply: (inputs, scheduler) =>
      inputs[0].pipe(
        map((x) => x.content),
        share()
      )
  }
};
